var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgNotification(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 20 27' }, props),
        React.createElement("path", { d: 'M10 20.25a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5zm0 1.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm0-20.5c-2.71 0-4.494 1.323-5.436 3.662-.672 1.67-.88 3.583-.88 6.347 0 2.338-.719 4.03-2.147 5.15-.56.44-.25 1.341.463 1.341h16c.689 0 1.013-.85.5-1.31-1.49-1.331-2.228-3.04-2.228-5.18 0-2.651-.2-4.541-.855-6.224C14.482 2.63 12.707 1.25 10 1.25zm0 1.5c3.648 0 4.772 2.892 4.772 8.51l.006.33c.055 1.755.552 3.294 1.487 4.6l.044.06H3.757l.017-.021c.94-1.308 1.41-2.973 1.41-4.97C5.183 5.525 6.3 2.75 10 2.75z' })));
}
export default SvgNotification;
//# sourceMappingURL=Notification.js.map